import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { roleBasedLogin, forgotPassword } from '../api';
import { useAuth } from '../AuthContext';
import PopupMessage from './PopupMessage';
import '../App.css';

const Login = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const [message, setMessage] = useState('');
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setIsLoading(true);

    if (isForgotPassword) {
      try {
        const res = await forgotPassword({ email: formData.email });
        if (res.success) {
          setMessage('Password reset email sent successfully.');
          setShowSuccessPopup(true);
          setTimeout(() => setIsForgotPassword(false), 2000);
        } else {
          setError(res.message || 'Failed to send email.');
          setShowErrorPopup(true);
        }
      } catch (err) {
        setError("Something went wrong. Please try again.");
        setShowErrorPopup(true);
      }
    } else {
      try {
        console.log('🔐 Login Component: Attempting login with email:', formData.email);
        const result = await roleBasedLogin({
          email: formData.email,
          password: formData.password,
        });

        console.log('📥 Login Component: Response received:', result);
        if (result.success) {
          console.log('✅ Login Component: Login successful');
          console.log('👤 User data:', result.data.user);
          console.log('🔑 Token received:', result.data.token?.substring(0, 50) + '...');

          // Store auth data using the login method from AuthContext
          login(result.data.user, result.data.token);

          console.log('💾 Login Component: Token stored in localStorage');
          console.log('🔍 Verify localStorage auth_token:', localStorage.getItem('auth_token')?.substring(0, 50) + '...');
          console.log('🔍 Verify localStorage user:', localStorage.getItem('user'));

          setMessage('✅ Login successful! Redirecting...');

          // Route based on role - all users go to candidates page
          setTimeout(() => {
            console.log('🚀 Login Component: Navigating to /candidates');
            navigate('/candidates');
          }, 1500);
        } else {
          console.error('❌ Login Component: Login failed -', result.message);
          setError(result.message || 'Login failed. Please try again.');
          setShowErrorPopup(true);
        }
      } catch (err) {
        console.error("💥 Login Component: Error during login:", err);
        console.error('Error stack:', err.stack);
        setError("An error occurred during login. Please try again.");
        setShowErrorPopup(true);
      }
    }
    setIsLoading(false);
  };

  return (
    <div className="login-wrapper">
      <div className="login-container">
        <div className="login-box">
          {isForgotPassword ? (
            <>
              <h1 className="welcome-heading">Forget Password</h1>
              <form onSubmit={handleSubmit}>
                <div className="login-form">
                  <input
                    type="email"
                    className="login-input"
                    id="email"
                    placeholder="Enter your registered email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                  <button type="submit" className="home-btn" disabled={isLoading}>
                    {isLoading ? 'Sending...' : 'Send Mail'}
                  </button>
                </div>
                {message && <p className="success-message">{message}</p>}
                {error && <p className="login-error">{error}</p>}
              </form>
              <p onClick={() => setIsForgotPassword(false)} className="login-link">Back</p>
            </>
          ) : (
            <>
              <h1 className="welcome-heading">Login</h1>
              <form onSubmit={handleSubmit}>
                <div className="login-form">
                  <input
                    type="email"
                    className="login-input"
                    id="email"
                    placeholder="Email Address"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    disabled={isLoading}
                  />
                  <input
                    type="password"
                    className="login-input"
                    id="password"
                    placeholder="Password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                    disabled={isLoading}
                  />
                  <button type="submit" className="home-btn" disabled={isLoading}>
                    {isLoading ? 'Logging in...' : 'Login'}
                  </button>
                </div>
              </form>          
              <p onClick={() => setIsForgotPassword(true)} className="login-link">Forgot Password?</p>
            </>
          )}
        </div>
        
        {/* Error Popup */}
        <PopupMessage
          visible={showErrorPopup}
          title="❌ Error"
          message={error}
          type="error"
          onClose={() => setShowErrorPopup(false)}
        />
        
        {/* Success Popup */}
        <PopupMessage
          visible={showSuccessPopup}
          title="✅ Success"
          message={message}
          type="success"
          onClose={() => setShowSuccessPopup(false)}
        />
      </div>
    </div>
  );
};

export default Login;
